import snakeCase from 'lodash/snakeCase';

function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : String(i);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var AnalyticsVendor = /*#__PURE__*/function () {
  function AnalyticsVendor(name) {
    _classCallCheck(this, AnalyticsVendor);
    _defineProperty(this, "name", 'AnalyticsVendor');
    this.enabled = true;
    this.name = name;
  }
  _createClass(AnalyticsVendor, [{
    key: "test",
    value: function test() {
      return false;
    }
  }]);
  return AnalyticsVendor;
}();

var getApplication = function getApplication() {
  var platform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'web';
  try {
    // Need navigator to catch Safari PWA. But TS don't like.
    var navigator = window.navigator;
    if (window.matchMedia('(display-mode: standalone)').matches || navigator.standalone === true) {
      return 'PWA';
    }
  } catch (e) {
    console.log('Analytics getApplication error', e);
  }
  return platform;
};
var COLLECTOR_NAME = 'fivetran';
var DEFAULT_COLLECTOR_URI = 'swssp.simplywall.st';
var schema = 'iglu:com.snowplowanalytics.iglu/anything-a/jsonschema/1-0-0';
var USER_ID_COOKIE = '_sws_uid';
var Fivetran = /*#__PURE__*/function (_AnalyticsVendor) {
  _inherits(Fivetran, _AnalyticsVendor);
  var _super = _createSuper(Fivetran);
  function Fivetran(platform) {
    var _this;
    var collectorUri = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_COLLECTOR_URI;
    _classCallCheck(this, Fivetran);
    _this = _super.call(this, 'Fivetran');
    _this.enabled = true;
    if (typeof window['snowplow'] === 'function') {
      console.log('Snowplow has registered on window object.');
      var TRACKER_OPTIONS = {
        // Initialise a tracker
        appId: getApplication(platform),
        platform: platform,
        cookieName: '_sws_',
        encodeBase64: false,
        eventMethod: 'post',
        discoverRootDomain: true,
        postPath: '/event-transformer/mono',
        forceSecureTracker: true,
        // Settting this to 0 prevents snowplow from blocking page navigations. The tradeoff being that a click event that caused the navigation
        // may not be immediately fired, as this timer waits for unfired events before allowing a navigation / page unload.
        // Instead we rely on snowplow firing any navigation events later, during the rest of the users session.
        //
        // See docs for further info https://docs.snowplow.io/docs/collecting-data/collecting-from-own-applications/javascript-trackers/web-tracker/previous-versions/javascript-tracker-v2/tracker-setup/initializing-a-tracker-2/#setting-the-page-unload-pause
        pageUnloadTimer: 0
      };
      window['snowplow']('newTracker', COLLECTOR_NAME, collectorUri, TRACKER_OPTIONS);
      window['snowplow']('setUserIdFromCookie', USER_ID_COOKIE);
    } else {
      process.env.NODE_ENV === 'production' && console.error('Snowplow is not registered on window object..');
    }
    return _this;
  }
  _createClass(Fivetran, [{
    key: "test",
    value: function test() {
      return typeof window['snowplow'] === 'function';
    }
  }, {
    key: "identify",
    value: function identify(userId) {
      try {
        if (typeof window['snowplow'] === 'function') {
          document.cookie = "".concat(USER_ID_COOKIE, "=").concat(userId, "; expires=Fri, 31 Dec 9999 23:59:59 GMT;domain=.simplywall.st;path=/");
          window['snowplow']('setUserId', userId);
          console.log('Snowplow setUserId', userId);
        } else {
          console.warn('Snowplow is not registered on window object..');
        }
      } catch (error) {
        console.error('Error setting identity in snowplow tracker..', error);
      }
    }
  }, {
    key: "unidentify",
    value: function unidentify() {
      try {
        if (typeof window['snowplow'] === 'function') {
          document.cookie = "".concat(USER_ID_COOKIE, "=; expires=Thu, 01 Jan 1970 00:00:00 GMT;domain=.simplywall.st;path=/");
          window['snowplow']('setUserId', '');
        } else {
          console.warn('Snowplow is not registered on window object..');
        }
      } catch (error) {
        console.error('Error setting identity in snowplow tracker..', error);
      }
    }
  }, {
    key: "track",
    value: function track(event, eventProperties) {
      try {
        if (typeof window['snowplow'] === 'function') {
          var data = Object.assign({
            event: event
          }, eventProperties);
          window['snowplow']("trackSelfDescribingEvent:".concat(COLLECTOR_NAME), {
            schema: schema,
            data: data
          });
          console.log('Snowplow trackSelfDescribingEvent', schema, data);
        } else {
          console.warn('Snowplow is not registered on window object..');
        }
      } catch (error) {
        console.error('Error tracking action in snowplow tracker..', error);
      }
    }
  }, {
    key: "page",
    value: function page(pathname) {
      try {
        if (typeof window['snowplow'] === 'function') {
          window['snowplow']('trackPageView');
          console.log('Snowplow trackPageView', pathname);
        } else {
          console.warn('Snowplow is not registered on window object..');
        }
      } catch (error) {
        console.error('Error tracking pageview in snowplow tracker..', error);
      }
    }
  }]);
  return Fivetran;
}(AnalyticsVendor);

var SWS = /*#__PURE__*/function (_AnalyticsVendor) {
  _inherits(SWS, _AnalyticsVendor);
  var _super = _createSuper(SWS);
  function SWS() {
    var _this;
    _classCallCheck(this, SWS);
    _this = _super.call(this, 'SWS analytics.dataLayer');
    _this.enabled = true;
    return _this;
  }
  _createClass(SWS, [{
    key: "test",
    value: function test() {
      return true;
    }
  }, {
    key: "identify",
    value: function identify() {
      return true;
    }
  }, {
    key: "unidentify",
    value: function unidentify() {
      return true;
    }
  }, {
    key: "track",
    value: function track(event, eventProperties) {
      if (typeof window !== 'undefined') {
        var _window, _window$analytics;
        var data = Object.assign({
          event: event
        }, eventProperties);
        (_window = window) === null || _window === void 0 ? void 0 : (_window$analytics = _window.analytics) === null || _window$analytics === void 0 ? void 0 : _window$analytics.dataLayer.push(data);
      }
    }
  }, {
    key: "page",
    value: function page() {
      return true;
    }
  }]);
  return SWS;
}(AnalyticsVendor);

var _excluded = ["type", "page", "subject", "modifier", "action"];
var Analytics = /*#__PURE__*/function () {
  function Analytics() {
    var platform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'web';
    var collectorUri = arguments.length > 1 ? arguments[1] : undefined;
    _classCallCheck(this, Analytics);
    _defineProperty(this, "identified", false);
    _defineProperty(this, "dataLayer", []);
    this.adapters = [new Fivetran(platform, collectorUri), new SWS()];
  }
  _createClass(Analytics, [{
    key: "log",
    value: function log() {
      if (process.env.NODE_ENV === 'production') return;
      for (var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++) {
        rest[_key] = arguments[_key];
      }
      console && console.info && console.info('%c🦄 Analytics', 'background: #222; color: #bada55; padding:4px;', rest);
    }
  }, {
    key: "isIdentified",
    value: function isIdentified() {
      return this.identified;
    }
  }, {
    key: "logout",
    value: function logout() {
      this.identified = false;
      this.callAdapters('unidentify', ['']);
    }
  }, {
    key: "dispatch",
    value: function dispatch(_ref) {
      var type = _ref.type,
        page = _ref.page,
        subject = _ref.subject,
        modifier = _ref.modifier,
        action = _ref.action,
        props = _objectWithoutProperties(_ref, _excluded);
      var snakedProps = Object.entries(props).reduce(function (a, b) {
        return Object.assign({}, a, _defineProperty({}, snakeCase(b[0]), b[1]));
      }, {});
      switch (type) {
        case 'page':
          {
            this.callAdapters(type, [props.path]);
            break;
          }
        case 'track':
          {
            var eventName = this.buildEventName(page, subject, modifier, action);
            for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              rest[_key2 - 1] = arguments[_key2];
            }
            eventName !== null ? this.callAdapters(type, [eventName, snakedProps]) : this.log.apply(this, ['Failed to build event name'].concat(rest));
            break;
          }
        case 'identify':
          {
            this.identified = this.callAdapters(type, [props.id, snakedProps]);
            break;
          }
        case 'unidentify':
          {
            this.identified = false;
            this.callAdapters(type, ['']);
            break;
          }
        default:
          {
            console.log('Unknown option:', type);
          }
      }
    }
  }, {
    key: "buildEventName",
    value: function buildEventName(page, subject, modifier, action) {
      if (typeof page === 'undefined' || typeof subject === 'undefined' || typeof action === 'undefined') {
        return null;
      }
      return "".concat(snakeCase(page), ".").concat(snakeCase(subject)).concat(modifier ? '.' + snakeCase(modifier) : '', "->").concat(snakeCase(action));
    }
  }, {
    key: "callAdapters",
    value: function callAdapters(type, args) {
      var _this = this;
      if (args.length < 1) {
        this.log("aborted calling analytics adapters, event ".concat(type, ", has no arguments"));
        return false;
      }
      this.adapters.forEach(function (adapter) {
        if (adapter.enabled && typeof adapter.test === 'function' && adapter.test()) {
          adapter[type] && adapter[type].apply(adapter, _toConsumableArray(args));
          _this.log.apply(_this, ["Pushed ".concat(process.env.NODE_ENV, " analytics event to ").concat(adapter.name)].concat(_toConsumableArray(args)));
        }
      });
      return true;
    }
  }]);
  return Analytics;
}();

export { Analytics as default };
